namespace GeniuzPOS.InitialData {
    export interface PsCustomerSurveyRow {
        Id?: number;
        SurveyCode?: string;
        Status?: number;
        StartDate?: string;
        EndDate?: string;
        TimeFg?: TimeFg;
        StartTime?: string;
        EndTime?: string;
        PosId?: string[];
        Question?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        UpdateDate?: string;
        ActiveBy?: string;
        Activedate?: string;
        PosFg?: PosFg;
        DtList?: PsCustomerSurveyDtRow[];
    }

    export namespace PsCustomerSurveyRow {
        export const idProperty = 'SurveyCode';
        export const nameProperty = 'SurveyCode';
        export const localTextPrefix = 'InitialData.PsCustomerSurvey';
        export const lookupKey = 'InitialData.PsCustomerSurvey';

        export function getLookup(): Q.Lookup<PsCustomerSurveyRow> {
            return Q.getLookup<PsCustomerSurveyRow>('InitialData.PsCustomerSurvey');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:Modify';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:CustomerSurvey:Modify';

        export declare const enum Fields {
            Id = "Id",
            SurveyCode = "SurveyCode",
            Status = "Status",
            StartDate = "StartDate",
            EndDate = "EndDate",
            TimeFg = "TimeFg",
            StartTime = "StartTime",
            EndTime = "EndTime",
            PosId = "PosId",
            Question = "Question",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            UpdateDate = "UpdateDate",
            ActiveBy = "ActiveBy",
            Activedate = "Activedate",
            PosFg = "PosFg",
            DtList = "DtList"
        }
    }
}
